import PlainTextCell from 'components/PlainTextCell';

import { parseDate } from 'utils/dates';
import type { ManagedOemSegmentType } from '../..';

interface CellProps {
  rowData: ManagedOemSegmentType;
}

export default function CreatedAtCell({ rowData: { createdAt } }: CellProps) {
  const [topLine, bottomLine] = parseDate(createdAt);

  return <PlainTextCell {...{ topLine, bottomLine }} />;
}
